import { render, staticRenderFns } from "./SendMailOptionDropdown.vue?vue&type=template&id=173a96bc&"
import script from "./SendMailOptionDropdown.vue?vue&type=script&lang=js&"
export * from "./SendMailOptionDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports